import Filter from '../../../../components/Filter';
import { FilterField } from '../../../../components/Filter/FilterField';
import cultivares from '../../../../services/estoque/cultivares';
import especies from '../../../../services/geral/especies';
import periodos from '../../../../services/geral/periodos';

const filters: FilterField[] = [
  { field: 'dataPlantio', type: 'dateInterval', label: 'Data de Plantio' },
  {
    field: 'cultivarId',
    type: 'autocomplete',
    label: 'Cultivar',
    service: cultivares,
    optionKey: 'id',
    optionLabel: 'descricaoCategoria',
    optionQuery: 'descricao',
  },
  {
    field: 'especieId',
    type: 'select',
    label: 'Espécie',
    service: especies,
    optionKey: 'id',
    optionLabel: 'descricao',
  },
  {
    field: 'periodoId',
    type: 'autocomplete',
    label: 'Período',
    service: periodos,
    optionKey: 'id',
    optionLabel: 'descricao',
  },
];

const Filters = () => (
  <Filter
    context="camposProducao"
    filters={filters}
  />
);

export default Filters;
